import { render, staticRenderFns } from "./EMelderComponentMeldungenChat.vue?vue&type=template&id=5f36860d&scoped=true"
import script from "./EMelderComponentMeldungenChat.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f36860d",
  null
  
)

export default component.exports